import React, { useCallback, useRef } from 'react';
import TransferOrderSelect from '../TransferOrderProduct/TransferOrderSelect';
import { useTranslation } from 'react-i18next';
import { Card, Form } from 'antd';
import ProductVariantsSelectionModal from '../TransferOrderProduct/ProductVariantsSelectionModal';
import { DynamicObjectType } from 'types/commons';
import { useRestContext } from 'components/form/RestInputContext';
import { uniqBy } from 'lodash';
import TableProductSelected from '../TransferOrderProduct/TableProductSelected';
import OrderSelected from '../TransferOrderProduct/OrderSelected';

const ProductCard = ({ isEdit }: { isEdit?: boolean }) => {
  const { t } = useTranslation();
  const { form } = useRestContext();

  const selectionModalRef = useRef<any>();

  const openSelectionModal = (id) => {
    selectionModalRef.current.open(id);
  };

  const onApplyVariants = useCallback((variants?: DynamicObjectType[]) => {
    // const currentVariants = form.getFieldValue('variantsApplied') || [];
    form.setFieldsValue({
      variantsApplied: uniqBy([...(variants || [])], 'id'),
    });
  }, []);

  const onApplyOrder = useCallback((order?: DynamicObjectType) => {
    // const currentVariants = form.getFieldValue('orderSelected') || [];
    form.setFieldsValue({
      // orderSelected: uniqBy([...currentVariants, ...([order] || [])], 'id'),
      orderSelected: order ? uniqBy([order], 'id') : [],
      toWarehouseId: order?.locationId,
    });
  }, []);

  return (
    <Card className="w-full" title={t('transferOrders.orders')}>
      <TransferOrderSelect
        openSelectionModal={openSelectionModal}
        onClearSelectedRow={() => {
          selectionModalRef.current.clearSelectedRow();
        }}
        onClearFormValues={() => {
          selectionModalRef.current.clearFormValues();
        }}
      />
      <Form.Item
        name="orderSelected"
        rules={[
          {
            required: true,
            message: t('Please select order!'),
          },
        ]}
        hidden
      />
      <Form.Item
        noStyle
        shouldUpdate={(prevValues, curValues) =>
          prevValues.orderSelected !== curValues.orderSelected
        }
      >
        {({ getFieldValue }) => {
          return (
            getFieldValue('orderSelected') && (
              <OrderSelected orderSelected={getFieldValue('orderSelected')} />
            )
          );
        }}
      </Form.Item>
      <Form.Item
        name="variantsApplied"
        rules={[
          {
            required: true,
            message: t('Please select order!'),
          },
        ]}
        hidden
      />

      <Form.Item
        noStyle
        shouldUpdate={(prevValues, curValues) =>
          prevValues.variantsApplied !== curValues.variantsApplied
        }
      >
        {({ getFieldValue }) => {
          return (
            <TableProductSelected
              variantsApplied={getFieldValue('variantsApplied')}
            />
          );
        }}
      </Form.Item>
      <Form.Item
        noStyle
        shouldUpdate={(prevValues, curValues) =>
          prevValues.variantsApplied !== curValues.variantsApplied
        }
      >
        {({ getFieldValue }) => {
          return (
            <ProductVariantsSelectionModal
              ref={selectionModalRef}
              onApplyVariants={onApplyVariants}
              onApplyOrder={onApplyOrder}
              variantSelected={getFieldValue('variantsApplied')}
              isEdit={isEdit}
            />
          );
        }}
      </Form.Item>
    </Card>
  );
};

export default ProductCard;
